import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcVolumeon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.657 3.554c1.05-1.254 3.093-.513 3.093 1.123v14.806c0 1.602-1.973 2.362-3.048 1.174l-3.46-3.825a.25.25 0 0 0-.186-.082H5A2.75 2.75 0 0 1 2.25 14v-3.5A2.75 2.75 0 0 1 5 7.75h2.033a.25.25 0 0 0 .191-.09zm1.593 1.123a.25.25 0 0 0-.442-.16L8.375 8.621a1.75 1.75 0 0 1-1.342.628H5c-.69 0-1.25.56-1.25 1.25V14c0 .69.56 1.25 1.25 1.25h2.056c.495 0 .966.21 1.298.576l3.46 3.825a.25.25 0 0 0 .436-.168z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.328 9.414a.75.75 0 0 1 1.017-.3 3.265 3.265 0 0 1 .003 5.737.75.75 0 0 1-.72-1.317 1.765 1.765 0 0 0 0-3.102.75.75 0 0 1-.3-1.018"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.248 5.705a.75.75 0 0 0-.48 1.42 5.131 5.131 0 0 1 .033 9.708.75.75 0 0 0 .49 1.417 6.631 6.631 0 0 0-.043-12.545"
  }));
}
var IcVolumeon = createNolIcon(/*#__PURE__*/forwardRef(SvgIcVolumeon));

export { IcVolumeon as I };
